import { Container, Graphics, Text } from '@pixi/react'
import { TextMetrics, TextStyle } from 'pixi.js'
import { memo, useEffect, useMemo, useState } from 'react'

const textStyle = new TextStyle({
  fill: '#FFFFFF',
  fontSize: 24,
})

interface ICurrentTimeProps {
  x?: number
  y?: number
}

export const CurrentTime = memo((props: ICurrentTimeProps) => {
  const [currentTime, setCurrentTime] = useState('')

  useEffect(() => {
    const updateTime = () => {
      const now = new Date()
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      setCurrentTime(`${hours}:${minutes}`)
    }

    updateTime()

    const interval = setInterval(updateTime, 1000)

    return () => clearInterval(interval)
  }, [])

  const textMetrics = useMemo(
    () => TextMetrics.measureText(currentTime, textStyle),
    [currentTime],
  )

  const backgroundPadding = { x: 12, y: 8 }
  const borderRadius = 8

  return (
    <Container name="CurrentTime" x={props.x ?? 1000} y={props.y ?? 30}>
      <Graphics
        draw={(g) => {
          g.clear()
          g.beginFill(0x000000, 0.5)
          g.drawRoundedRect(
            -backgroundPadding.x,
            -textMetrics.height / 2 - backgroundPadding.y,
            textMetrics.width + backgroundPadding.x * 2,
            textMetrics.height + backgroundPadding.y * 2,
            borderRadius,
          )
          g.endFill()
        }}
      />
      <Text text={currentTime} anchor={[0, 0.5]} style={textStyle} />
    </Container>
  )
})
